import {call, put, takeLatest, race, take} from 'redux-saga/effects';
import * as Api from '../api';
import { AppAction } from '../../../Store/types';
import * as Routines from "../routines";
import { DeviceHardwareEnum } from '../../../DeviceHardwareEnum';
import {SettingDTO} from "@Safemate/Settings/types";

export interface Initialize{
  deviceId: string;
  dehaId: DeviceHardwareEnum;
  deviceSnNum?: string;
}

function* initialize(action: AppAction<Initialize>){
  try {
    
    const device = yield call(Api.getDevice, action.payload);

    const capabilities = yield call(Api.getCapabilities, action.payload);

    const supportDeviceMac = yield call(Api.getSupportDeviceMac);

    //const deviceSetting:any  = yield call(Api.getDeviceSetting, device.deviceSNNum);


    yield put(Routines.initialize.success({device, capabilities, supportDeviceMac, deviceSetting: {}, ...action.payload}));
  }
  catch(e){
    yield put(Routines.initialize.failure());
  }
  yield put(Routines.initialize.fulfill());
}

function* getUser(action: AppAction<Initialize>){
  try {
    const user = yield call(Api.getUser);
    yield put(Routines.initializeUser.success(user));
  }
  catch(e){
    yield put(Routines.initializeUser.failure());
  }
}

function* initializationSaga(){
    yield takeLatest(Routines.initialize.TRIGGER, initialize);
    yield takeLatest(Routines.initializeUser.TRIGGER, getUser);
}

export default initializationSaga;
